import type { Snippet } from 'svelte'
import { dequal } from 'dequal'

/* 
    This utility function is used to check whether the value of a field in an entity object has been updated/modified,
    and return a Snippet that represents an indicator when value is modified.
    parameters:
        entity: the object that will get updated
        originalEntity: the initial state of the object before any changes made
        snippet: a snippet to use as the indicator
        fieldName: the name of the field in the object that you need for comparison (the keys of the object)
*/
export function getModifiedIndicator<T>(entity: T, originalEntity: T, snippet: Snippet) {
	return (fieldName: keyof T) => {
		if (!isNaN(Number(entity[fieldName])) && !isNaN(Number(originalEntity[fieldName]))) {
			// Here, 0 was the default for most of the currency input value. Setting the value to 0 will return 0.00, which will not be equal to the original value
			// With the Number() constructor, we can make sure that 0.00 is converted to 0
			return Number(entity[fieldName]) !== Number(originalEntity[fieldName]) ? snippet : undefined
		}

		return !dequal(entity[fieldName], originalEntity[fieldName]) ? snippet : undefined
	}
}
